// extracted by mini-css-extract-plugin
export default {"DateTag":"DateTag_l_OCQ"};